import ProjectInfoCard from "~/components/ProjectInfoCard"
import OmniAuthProviderSelector from "~/components/OmniAuthProviderSelector"
import RecruiterHeader from "~/components/RecruiterHeader"
import { IOmniAuthProvider, IProjectIntro } from "~/types/recruiter"

type IRecruiterScreenLoginProps = {
  providers: IOmniAuthProvider[]
  intro: IProjectIntro
  enableDevLogin: boolean
  relayState?: string
}

export default function RecruiterScreenLogin({
  intro,
  providers,
  relayState,
  enableDevLogin
}: IRecruiterScreenLoginProps) {
  return (
    <div className="min-h-full flex flex-col bg-primary-100">
      <RecruiterHeader buttons={enableDevLogin ? ["dev-login"] : []} />

      <main className="flex-1 flex items-start justify-center px-6 py-8 md:px-12 md:py-12">
        <div className="w-full max-w-5xl flex flex-col md:flex-row gap-6 md:gap-8 items-start">
          <div className="w-full md:w-1/2">
            <ProjectInfoCard {...intro} />
          </div>
          <div className="w-full md:w-1/2 md:max-w-md">
            <OmniAuthProviderSelector
              providers={providers}
              relayState={relayState}
            />
          </div>
        </div>
      </main>
    </div>
  )
}
